import React from "react";

const TOWN_URL = "https://tingtown.com";
const DISTRICT_URL = "https://tingtown.com/developer-district";

// Cross-promo ribbon — turns CreditCost users into T.I.N.G Town visitors.
export function TownRibbon() {
  return (
    <div className="flex items-center justify-center gap-2 py-4 text-[13px]" data-testid="town-ribbon">
      <span className="text-muted-foreground">Powered by</span>
      <a
        href={TOWN_URL}
        target="_blank"
        rel="noreferrer"
        className="font-bold text-[#1E90FF] transition-opacity hover:opacity-80"
        data-testid="town-ribbon-brand"
      >
        T.I.N.G Town
      </a>
      <span className="text-muted-foreground">·</span>
      <a
        href={DISTRICT_URL}
        target="_blank"
        rel="noreferrer"
        className="font-semibold text-[#1E90FF] transition-opacity hover:opacity-80"
        data-testid="town-ribbon-more"
      >
        See more apps →
      </a>
    </div>
  );
}
